/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Device Management
 * Device Manager API CRUD https://bitbucket.org/nwaveio/device-management-openapi/src/master/
 *
 * The version of the OpenAPI document: 2.1.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    Group,
    ResponseReason,
} from './';

/**
 * @export
 * @interface ResponseGroupsWithTotal
 */
export interface ResponseGroupsWithTotal {
    /**
     * @type {Array<Group>}
     * @memberof ResponseGroupsWithTotal
     */
    data: Array<Group>;
    /**
     * @type {number}
     * @memberof ResponseGroupsWithTotal
     */
    total: number;
    /**
     * @type {ResponseReason}
     * @memberof ResponseGroupsWithTotal
     */
    reason: ResponseReason;
    /**
     * @type {string}
     * @memberof ResponseGroupsWithTotal
     */
    message: string;
}
